"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAisleWeight = updateAisleWeight;
async function updateAisleWeight(machineRepo, machineId, aisleCode, newWeight) {
    return await machineRepo.updateAisleWeight(machineId, aisleCode, newWeight);
}
